import {useEffect, useState} from 'react';
import {Descriptions, InputNumber, Flex} from 'antd';

/**
 * 数字人席位套餐设置
 */
export default function (props){
    const [price, setPrice] = useState(props?.data?.option?.defaultValue?.price);
    const [month, setMonth] = useState(props?.data?.option?.defaultValue?.month);
    const [countNum, setCountNum] = useState(props?.data?.option?.defaultValue?.countNum);

    useEffect(()=>{
        props.verification(props.data, {
            price: Math.round(price * 100),
            month: month,
            countNum: countNum,
        })
    },[props.data, price, month, countNum])

    return <Descriptions
      bordered
      column={1}
      size={"small"}
      labelStyle={{width: "100px"}}
    >
        <Descriptions.item label={'价格'}>
            <InputNumber
                style={{width: "100%"}}
                min={0}
                max={999999}
                step={1}
                precision={2}
                controls={false}
                placeholder={'请填写价格'}
                addonAfter={"灵能"}
                value={price}
                onChange={(value) => {
                    setPrice(value)
                }}
            />
        </Descriptions.item>
        <Descriptions.item label={'包含席位'}>
            <InputNumber
              style={{width: "100%"}}
              min={1}
              max={999999}
              step={1}
              precision={0}
              controls={false}
              placeholder={'请填写调用次数'}
              addonAfter={"个"}
              value={countNum}
              onChange={(value) => {
                  setCountNum(value)
              }}
            />
        </Descriptions.item>
        <Descriptions.item label={'套餐时长'}>
            <InputNumber
              style={{width: "100%"}}
              min={1}
              max={12}
              step={1}
              precision={0}
              controls={false}
              placeholder={'请填写套餐时长'}
              addonAfter={"个月"}
              value={month}
              onChange={(value) => {
                  setMonth(value)
              }}
            />
        </Descriptions.item>
    </Descriptions>
}